import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8da48ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid font-goldplay" }
const _hoisted_2 = { class: "row align-items-center border-bottom border-dark m-1" }
const _hoisted_3 = { class: "col-11 py-0" }
const _hoisted_4 = { class: "row align-items-center border-bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Day/Date ", -1))
const _hoisted_6 = { class: "col d-flex align-items-center font-14px" }
const _hoisted_7 = { class: "row align-items-center border-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Time ", -1))
const _hoisted_9 = { class: "col font-14px" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 py-2 px-0 text-black row-header" }, " Title ", -1))
const _hoisted_11 = { class: "col d-flex align-items-center font-14px" }
const _hoisted_12 = {
  key: 0,
  class: "session-list-item__info-badge fw-bold font-14px"
}
const _hoisted_13 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_14 = { class: "col-3 py-2 px-0 text-black row-header" }
const _hoisted_15 = { class: "col d-flex align-items-center font-14px" }
const _hoisted_16 = {
  key: 0,
  class: "mb-0 me-2 pe-4"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "col-1" }
const _hoisted_19 = { class: "dropstart" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn p-0 rounded-0 border-0 kebab-button",
  "data-bs-toggle": "dropdown",
  "aria-label": "open session menu"
}, null, -1))
const _hoisted_21 = { class: "dropdown-menu p-0 rounded-0 border-0 shadow" }

import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'
import CheckCircleGrey from '@/icons/CheckCircleGrey.vue'
import TagInfoModal from '../TagInfoModal/TagInfoModal.vue'
import CoachingSessionInfoModal from '../CoachingSessionInfoModal/CoachingSessionInfoModal.vue'
import DocumentDownloadModal from '../DocumentDownloadModal/DocumentDownloadModal.vue'
import { useClassroomStudentService } from '../ClassroomStudentService'
import { CourseTag } from '@/types/api'
import { downloadFile } from '@/utils/downloadFile'
import RecordingIcon from '@/icons/RecordingIcon.vue'
import DocumentIcon from '@/icons/DocumentIcon.vue'
import MultiTagIcon from '@/icons/icon_multitag.vue'


import { defineComponent, defineProps, ref } from 'vue'
const __default__ = defineComponent({
  name: 'PastSessionMoblieListItem'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    instructorName: {},
    disabled: { type: Boolean },
    isLastRow: { type: Boolean },
    eventTags: {},
    isLsat: { type: Boolean }
  },
  setup(__props: any) {

const props =
  __props

const classroomStudentService = useClassroomStudentService()
const dateString = props.modelValue.localStartDateTime.toLocaleString('en-us', {weekday: 'long', month: 'short', day: 'numeric', year: 'numeric'})
const hasDocuments = props.modelValue.event.documentFileNames?.length > 0
const showInstructorRow = props.isLsat || hasDocuments || (props.modelValue.event.recordingLink?.length > 0)
const showSessionInfo = ref(false)
const showTagInfo = ref(false)
const showDocumentDownloadModal = ref(false)
const documentsDownloading = ref([''])

function handleSessionInfoClick() {
  showSessionInfo.value = true
}

function handleDownloadDocuments() {
  if (props.modelValue.event.documentFileNames.length === 1) {
    downloadFiles([props.modelValue.event.documentFileNames[0]])
  } else {
    openDocumentDownloadModal()
  }
}
async function downloadFiles(fileNameList: string[]) {
  documentsDownloading.value = [ ...fileNameList ]
  try{
      await fileNameList.forEach(async (fileName) => {
        const file = await classroomStudentService.fetchEventDocument(props.modelValue.sessionId, fileName)
        if (file) {
          downloadFile(file, fileName)
          documentsDownloading.value = documentsDownloading.value.filter(f => f !== fileName)
        }
    })
  } catch (e) {
    documentsDownloading.value = []
    throw e
  }
}

function openDocumentDownloadModal() {
  showDocumentDownloadModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_ctx.modelValue.showRegistered)
                ? (_openBlock(), _createBlock(CheckCircleGrey, {
                    key: 0,
                    class: "checkmark-svg me-2 size-24px",
                    role: "img",
                    "aria-label": "currently enrolled session"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_unref(dateString)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.modelValue.localStartEndTime), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['row align-items-center', { 'border-bottom': _unref(showInstructorRow) }])
          }, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createTextVNode(_toDisplayString(_ctx.modelValue.event.title) + " ", 1),
              _createElementVNode("button", {
                class: "btn ms-2 p-0 lh-1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showTagInfo.value = true))
              }, [
                (_ctx.eventTags.length == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(_ctx.eventTags[0].abbreviation) + ") ", 1))
                  : (_ctx.eventTags.length > 1)
                    ? (_openBlock(), _createBlock(MultiTagIcon, {
                        key: 1,
                        class: "size-20px"
                      }))
                    : _createCommentVNode("", true)
              ])
            ])
          ], 2),
          (_unref(showInstructorRow))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.isLsat ? "Instructor" : ""), 1),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.isLsat)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.instructorName), 1))
                    : _createCommentVNode("", true),
                  (_ctx.modelValue.event.recordingLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "link-btn me-4",
                        href: _ctx.modelValue.event.recordingLink,
                        target: "_blank"
                      }, [
                        _createVNode(RecordingIcon, { class: "size-24px" })
                      ], 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  hasDocuments
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn p-0 lh-1 rounded-0",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleDownloadDocuments()))
                      }, [
                        _createVNode(DocumentIcon, { class: "size-20px" })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "dropdown-item p-3 px-4 lh-base",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSessionInfoClick()))
              }, " Session" + _toDisplayString(_ctx.isLsat ? "/Instructor" : "") + " Info ", 1),
              hasDocuments
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "dropdown-item p-3 px-4 lh-base border-top",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleDownloadDocuments()))
                  }, " Download Documents "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(TagInfoModal, {
      visible: showTagInfo.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showTagInfo).value = $event)),
      "coaching-session": _ctx.modelValue,
      "event-tags": _ctx.eventTags
    }, null, 8, ["visible", "coaching-session", "event-tags"]),
    _createVNode(CoachingSessionInfoModal, {
      visible: showSessionInfo.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showSessionInfo).value = $event)),
      "coaching-session": _ctx.modelValue
    }, null, 8, ["visible", "coaching-session"]),
    _createVNode(DocumentDownloadModal, {
      visible: showDocumentDownloadModal.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((showDocumentDownloadModal).value = $event)),
      "file-names": _ctx.modelValue.event.documentFileNames ?? [],
      "documents-downloading": documentsDownloading.value,
      onDownloadFiles: downloadFiles
    }, null, 8, ["visible", "file-names", "documents-downloading"])
  ], 64))
}
}

})